"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const react_1 = __importDefault(require("react"));
require("./input.css");
;
/**
 * Main component.
 * @name Input
 * @param {InputProps}
 * @returns {<Input />}
*/
const Input = ({ type = "text", error = false, label, labelMobile, placeholder, onChange, value, disabled, errorMessage, name, maxLength, minLength, min, max, required, }) => {
    return (react_1.default.createElement("div", { className: "input-wrapper" },
        react_1.default.createElement("div", { className: "bg-white " +
                (error ? "input-error " : "") },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: labelMobile ? "label desktop" : "label" }, label),
                labelMobile && react_1.default.createElement("span", { className: "label mobile" }, labelMobile)),
            react_1.default.createElement("div", null,
                react_1.default.createElement("input", { type: type, value: value, placeholder: placeholder, onChange: onChange, className: "input", name: name, minLength: minLength, maxLength: maxLength, min: min, max: max, disabled: disabled, required: required }))),
        error ? react_1.default.createElement("div", { className: "error" }, errorMessage) : null));
};
exports.Input = Input;
//# sourceMappingURL=input.js.map